'use strict';

const FEDERATION_SUPPORTED_TYPES = [
    'script'
];

exports.FEDERATION_SUPPORTED_TYPES = FEDERATION_SUPPORTED_TYPES;
